import styled from 'styled-components';

const label = styled.span`
  font-weight: 600;
`;

const value = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

const link = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 150px;
  flex-direction: column;
`;

const title = styled.h5`
  font-weight: 600;
  margin-top: 1rem;
`;

const docs = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
`;

const valueinput = styled.input`
  &:focus-visible {
    outline: 0;
  }
  width: 100%;
  color: #414042;
  font-weight: 400;
  padding: 5px 10px;
  height: 34lpx;
  background: #e6e7e8;
  overflow-x: scroll;
  border: 1px solid #a7a9ac;
  border-radius: 6px;
`;

const Info = {
  Label: label,
  Value: value,
  Valueinput: valueinput,
  Link: link,
  Docs: docs,
  Title: title,
};

export default Info;
